<template>
    <div class="goldBox">
        <img class="bgimg" v-if="itemData.topicPic" :src="`/manager/fileserver/file/download?id=${itemData.topicPic}`" />
        <div class="gameBox">
            <div class="gameTitle">{{itemData.name}}</div>
            <div class="gameBtn" @click="gotoGame">点我抢钱</div>
            <div class="gameExplain">
                <div class="gameExplainTitle">游戏说明：</div>
                <div class="gameExplainContent">{{itemData.topic}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "gameGold",
        mounted() {
            if(localStorage.getItem("openId")){
                let dt = new URLSearchParams()
                dt.append('openid',localStorage.getItem("openId"))
                this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
                    if(data.code == 200 && data.data != null){
                        // console.log(data.data)
                        let dataStr = JSON.stringify(data.data)
                        if(data.data.cardAccount){
                            localStorage.setItem("login", '1')
                        }else{
                            localStorage.setItem("login", '0')
                        }

                        localStorage.setItem("userData", dataStr)
                    }else{
                        this.UI.Toast.failed(data.message)
                    }
                })
            }else{
                let dtcode = new URLSearchParams()
                dtcode.append('code', window.MyCode)
                this.$http.post('/sangto-wrm/vip/member/getByCode',dtcode).then(({data})=>{
                    // console.log(JSON.stringify(data.data))
                    let openid = data.data.openid
                    // let openid = 'osyLxsgbhd6D7oyVgEHS9ar-4Nfk'
                    localStorage.setItem("code", JSON.stringify(data.data))
                    localStorage.setItem("openId", openid) //保存openid
                    // console.log(data.data.member)
                    if(data.data.member){
                        localStorage.setItem("login", '1')
                    }else{
                        localStorage.setItem("login", '0')
                    }
                    let dt = new URLSearchParams()
                    dt.append('openid',openid)
                    this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
                        if(data.code == 200 && data.data != null){
                            // console.log(data.data)
                            let dataStr = JSON.stringify(data.data)
                            if(data.data.cardAccount){
                                localStorage.setItem("login", '1')
                            }else{
                                localStorage.setItem("login", '0')
                            }

                            localStorage.setItem("userData", dataStr)
                        }else{
                            this.UI.Toast.failed(data.message)
                        }
                    })
                })
            }



            this.itemData = JSON.parse(this.$route.query.itemData)

            document.title = "点屏成金"
        },
        data(){
            return{
                itemData:''
            }
        },
        methods:{
            gotoGame(){
                this.$http.get('/sangto-wrm/activity/game/getPrize',{
                    params:{
                        gameId: this.itemData.id,   //'8a2902066366c716016366ee565d0000',
                        openid:localStorage.getItem("openId")
                    }
                }).then(({data}) => {

                    if(data.code == -1){
                        this.UI.Toast.info(data.message)
                        return
                    }
                    let dt = data.data
                    this.UI.Dialog.confirm({
                        title:'抽奖提示',
                        content:dt.content,
                        cancelText: '返回',
                        confirmText: "继续抽奖",
                        onCancel:()=>{
                            this.$router.go(-1)
                        }
                    })

                    let dta = new URLSearchParams()
                    dta.append('openid',localStorage.getItem("openId"))
                    this.$http.post('/sangto-wrm/vip/member/getByOpenId',dta).then(({data})=>{ //使用openid获取会员信息
                        if(data.code == 200 && data.data != null){
                            // console.log(data.data)
                            let dataStr = JSON.stringify(data.data)
                            if(data.data.cardAccount){
                                localStorage.setItem("login", '1')
                            }else{
                                localStorage.setItem("login", '0')
                            }

                            localStorage.setItem("userData", dataStr)
                        }else{
                            this.UI.Toast.failed(data.message)
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped lang="scss">
.goldBox{
    position: relative;
    width: 100%;
    height: 100%;
    .bgimg{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
    }
    .gameBox{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .gameTitle{
        margin-top: 10px;
        color: yellow;
        font-size: 16px;
        letter-spacing: 1px;
    }
    .gameBtn{
        width: 220px;
        height: 40px;
        border-radius: 6px;
        line-height: 40px;
        text-align: center;
        position: absolute;
        font-size: 16px;
        letter-spacing: 2px;
        top: 38%;
        background-color: #faa23f;
        color: #fffee2;
        box-shadow: 1px 1px 4px 0 rgba(250,214,160,0.1);
    }
    .gameExplain{
        display: flex;
        width: 86%;
        font-size: 14px;
        position: absolute;
        top:68%;
        color: #fff2b3;
        border: 1px solid #ffab65;
        padding: 10px;
        border-radius: 5px;
    }
    .gameExplainTitle{
        flex: none;
        width: 80px;
    }
    .gameExplainContent{
        flex: 1;
        letter-spacing: 1px;
    }

}
</style>
